import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
var VueCookie = require('vue-cookie');

Vue.config.productionTip = false
Vue.prototype.$appmode = "production";
//Vue.prototype.$appmode = "development";
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueCookie);

new Vue({
  render: h => h(App),
}).$mount('#app')
